import { useParams, Link as RouterLink } from 'react-router-dom';
import { Grid, Button, Typography } from '@material-ui/core';
import ChatBox from './ChatBox';
import { Page, Header, Content, InfoCard } from '@backstage/core-components';
import usecases from './usecases.json';

export const UseCaseDetailPage = () => {
  const { id } = useParams();
  const usecase = usecases.find(u => u.id === id) || usecases[0];

  return (
    <Page themeId="home">
      <Header title={usecase.title} />
      <Content>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="body1" paragraph>
              {`Use Case ${usecase.id} Development cards`}
            </Typography>
            <div style={{ marginTop: 8, marginBottom: 8 }}>
              <InfoCard title="Workflow Assistant">
                <ChatBox height={600} useCaseId={id} />
              </InfoCard>
            </div>
            <Button
              variant="outlined"
              color="primary"
              component={RouterLink}
              to="/catalog/use-cases"
            >
              Back to Use Cases
            </Button>
          </Grid>

          <Grid item md={6} xs={12}>
            <InfoCard title="Artifact Repository">
              <Typography variant="body2" paragraph>
                Open the list of repositories in the catalog.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                component={RouterLink}
                to="/catalog/list"
              >
                Open Repository List
              </Button>
            </InfoCard>
          </Grid>

          <Grid item md={6} xs={12}>
            <InfoCard title="co-IDE">
              <Typography variant="body2" paragraph>
                Launch Web-based IDE with a selected repository.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                component={RouterLink}
                to="/co-ide"
              >
                Launch
              </Button>
            </InfoCard>
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};

export default UseCaseDetailPage;
